<br>

<div class="visits-table-wrapper">
    <app-common-list-table
        [request]="getRequest"
        [cols]="cols"
        [globalConditionalStyle]="globalConditionalStyle"
        [globalVisualTransform]="globalVisualTransform"
        [filtering]="filtering"
        [showExportCsv]="true">

        <ng-template #thEnd>
            <th>
                <p class="d-flex justify-content-center mb-0">Acciones</p>
            </th>
        </ng-template>
        <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
            <td>
                <div class="px-3">
                    <app-action-buttons
                        [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
                        (showRowButtonEvent)="show('info', data.data)"
                        (editRowButtonEvent)="edit(data.data)"
                        (deleteRowButtonEvent)="show('delete', data.data)">
                    </app-action-buttons>
                </div>
            </td>
        </ng-template>
        <ng-template #header>
            @if (showWarning) {
                <div class="visits-chart-warning">
                    Debes seleccionar todas las opciones del marco para generar la gráfica.
                </div>
            }
            <div class="visits-filter-bar">
                <div class="visits-filter-control">
                    <span class="visits-filter-label">Semana</span>
                    <p-select
                        [options]="weeks"
                        [(ngModel)]="currentWeek"
                        optionLabel="name"
                        styleClass="visits-filter-select"
                        (onChange)="filterValues()"
                        [appendTo]="'body'">
                    </p-select>
                </div>
                <div class="visits-filter-control">
                    <span class="visits-filter-label">Año</span>
                    <p-select
                        [options]="years"
                        [(ngModel)]="currentYear"
                        optionLabel="name"
                        styleClass="visits-filter-select"
                        (onChange)="filterValues()"
                        [appendTo]="'body'">
                    </p-select>
                </div>
                <div class="visits-filter-control">
                    <span class="visits-filter-label">Trampas</span>
                    <p-select
                        [options]="trampas"
                        [(ngModel)]="trampaSelected"
                        optionLabel="name"
                        styleClass="visits-filter-select"
                        (onChange)="filterValues()"
                        [appendTo]="'body'">
                    </p-select>
                </div>
                <div class="visits-filter-control visits-filter-control--wide">
                    <span class="visits-filter-label">Plagas</span>
                    <p-multiSelect
                        defaultLabel="Selecciona plaga"
                        [options]="plagasList"
                        [(ngModel)]="plagaSelected"
                        [filter]="false"
                        optionLabel="name"
                        styleClass="visits-filter-select"
                        [panelStyle]="{ minWidth: '5em' }"
                        [appendTo]="'body'">
                    </p-multiSelect>
                </div>
                <div class="visits-filter-action">
                    <button class="btn btn-info visits-chart-button" type="button" (click)="show('grafica', model)">
                        <i class="fa fa-bar-chart" aria-hidden="true"></i>&nbsp;Generar gráfica
                    </button>
                </div>
            </div>
        </ng-template>
    </app-common-list-table>
</div>

<app-modals
    [view]="this"
    [form]="form?.formFields"
    [serverUrl]="serverUrl"
    [previousData]="model"
    [recordHasAssociatedData]="false"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest">
</app-modals>

<p-dialog
    *ngIf="canShow['grafica']"
    header="Cantidad Plagas"
    [(visible)]="canShow['grafica']"
    [responsive]="true"
    [style]="{ width: '70vw', minWidth: '40vw' }">
    <img
        *ngIf="loadingCharts"
        class="visits-chart-loader"
        src="assets/icon/load.gif"
        alt="Cargando gráfica"
        srcset="">

    <div *ngIf="!loadingCharts">
        <p-chart type="line" [data]="dataPlagasChart" [options]="basicOptions">
        </p-chart>
    </div>

    <p-footer>
        <button class="btn btn-dark mx-2" type="button" (click)="hide('grafica')">Cerrar</button>
    </p-footer>
</p-dialog>
